import glamorous from 'glamorous';

const PlayerBarValue = glamorous.span(
  ({ disabled, tabular, theme }) => ({
    fontSize: theme.fontSize.small,
    opacity: disabled ? 0.25 : undefined,
    padding: tabular ? '0 0.5em' : undefined,
    [theme.mediaQuery.tabletLandscapeAndUp]: {
      width: tabular ? '5.5rem' : undefined
    }
  }),
  ({ dropped, theme }) =>
    dropped
      ? {
          textDecoration: `line-through ${theme.color.black}`,
          color: 'pink'
        }
      : {}
);

export default PlayerBarValue;
